const userActionTypes = {
  LOG_IN_SUCCESS: "LOG_IN_SUCCESS",
  LOG_IN_FAILURE: "LOG_IN_FAILURE",
  LOG_IN_START: "LOG_IN_START",

  SIGN_OUT_START: "SIGN_OUT_START",
  SIGN_OUT_SUCCESS: "SIGN_OUT_SUCCESS",
  SIGN_OUT_FAILURE: "SIGN_OUT_FAILURE",

  SIGN_UP_START: "SIGN_UP_START",
  SIGN_UP_SUCCESS: "SIGN_UP_SUCCESS",
  SIGN_UP_FAILURE: "SIGN_UP_FAILURE",

  VERIFY_EMAIL_START: "VERIFY_EMAIL_START",
  VERIFY_EMAIL_SUCCESS: "VERIFY_EMAIL_SUCCESS",
  VERIFY_EMAIL_FAILURE: "VERIFY_EMAIL_FAILURE",

  FORGOT_PASSWORD_START: "FORGOT_PASSWORD_START",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILURE: "FORGOT_PASSWORD_FAILURE",

  RESET_PASSWORD_START: "RESET_PASSWORD_START",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
  RESET_PASSWORD_FAILURE: "RESET_PASSWORD_FAILURE",
  RESEND_VALIDATION_EMAIL_START: "RESEND_VALIDATION_EMAIL_START",
  RESEND_VALIDATION_EMAIL_SUCCESS: "RESEND_VALIDATION_EMAIL_SUCCESS",
  RESEND_VALIDATION_EMAIL_FAILURE: "RESEND_VALIDATION_EMAIL_FAILURE",

  UPLOAD_USER_PHOTOS_START: "UPLOAD_USER_PHOTOS_START",
  UPLOAD_USER_PHOTOS_SUCCESS: "UPLOAD_USER_PHOTOS_SUCCESS",
  UPLOAD_USER_PHOTOS_FAILURE: "UPLOAD_USER_PHOTOS_FAILURE",

  UPDATE_PROFILE_DATA_START: "UPDATE_PROFILE_DATA_START",
  UPDATE_PROFILE_DATA_SUCCESS: "UPDATE_PROFILE_DATA_SUCCESS",
  UPDATE_PROFILE_DATA_FAILURE: "UPDATE_PROFILE_DATA_FAILURE",
  UPDATE_PROFILE_DATA_VALIDATE: "UPDATE_PROFILE_DATA_VALIDATE",

  FETCH_USER_COINS_START: "FETCH_USER_COINS_START",
  FETCH_USER_COINS_SUCCESS: "FETCH_USER_COINS_SUCCESS",
  FETCH_USER_COINS_FAILURE: "FETCH_USER_COINS_FAILURE",
  CHECK_USER_SESSION: "CHECK_USER_SESSION",

  UPDATE_USER_LOCATION: "UPDATE_USER_LOCATION",

  SYNC_USER_DATA_START: "SYNC_USER_DATA_START",
  SYNC_USER_DATA_SUCCESS: "SYNC_USER_DATA_SUCCESS",
  SYNC_USER_DATA_FAILURE: "SYNC_USER_DATA_FAILURE",
};

export default userActionTypes;
